@if (!prefetching && !data?.conditionalRender) {
  <ul>
    <li>
      <button
        [disabled]="data.invalid || downloading"
        (click)="downloadBlob(true)"
        htm-button
        class="text-center"
        data-test-id="sidebar-file-download-button"
        >
        {{'downloadFile' | translate}}
      </button>
    </li>
  </ul>
}

@if (!prefetching && data?.conditionalRender) {
  <block theme="sidebar">
    @if (!prefetching) {
      <block-title ngClass="type-downloadFile">
        <h2>{{ 'downloadFile' | translate }}</h2>
      </block-title>
    }
    <block-content>
      @if (!prefetching) {
        <ul>
          <li>
            <button
              [disabled]="data.invalid || downloading"
              (click)="saveFile()"
              htm-button
              class="text-center"
              data-test-id="sidebar-file-download-button"
              >
              {{'downloadFile' | translate}}
            </button>
          </li>
        </ul>
      }
    </block-content>
  </block>
}
